<template>
  <div class="sun not-full main">
    <div class="title">
      대출정보
    </div>
    <div class="description">
      예금주는 대표자(신청법인)과 동일해야 함
    </div>
  </div>
</template>

<script>
export default {
  name: 'DocumentLoanTitle'
}
</script>

<style lang="scss" scoped>
.main {
  width: 100%;
  padding-top: 10px;
  padding-bottom: 10px;
  line-height: 26px;

  .title {
    width: 100%;
    color: #1BAAF1;
    font-size: 18px;
    font-weight: bold;
  }

  .description {
    width: 100%;
    font-size: 16px;
  }
}
</style>
